import { Button } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../alerts/alertSlice";
import { authAPI } from "../../../api/auth/auth";
import { adminPricesApi } from "../../../api/admin/prices";

const weights = [];

for (let i = 1; i <= 80; i++) {
    weights.push((i / 4).toFixed(2));
}

const isNewPriceValid = (weight, price) => {
    if (!weight || !+price) return false;

    return true;
};

const CreateOverPrice = ({
    regionID,
    packageType,
    senderCityWithOfficeID,
    reloadOverPrices,
}) => {
    const dispatch = useDispatch();

    const [price, setPrice] = useState("");
    const [weight, setWeight] = useState("");

    const handleCreateOverPrice = async () => {
        if (!isNewPriceValid(weight, price)) return;

        if (!+regionID || !packageType || !+senderCityWithOfficeID) return;

        let resp = await adminPricesApi.createOverPrice(
            regionID,
            packageType,
            senderCityWithOfficeID,
            weight,
            price
        );

        if (!resp.ok) {
            dispatch(
                pushAlert({
                    message: resp.err,
                    delay: 1000,
                    type: "danger",
                })
            );
            return;
        }

        reloadOverPrices();
        setWeight("");
        setPrice("");
        dispatch(
            pushAlert({
                message: "Over price created",
                delay: 2000,
                type: "success",
            })
        );
    };

    return (
        <div className="flex gap-10 items-center">
            <h1 className="text-lg">Create over price</h1>

            {/* weight select */}
            <div className="flex gap-2 items-center">
                <span className="font-medium">weight</span>
                <select
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    className="border p-2 border-black"
                >
                    <option value={""}></option>
                    {weights.map((weight) => (
                        <option key={weight} value={weight}>
                            {weight}
                        </option>
                    ))}
                </select>
            </div>

            {/* price input */}
            <div className="flex gap-2 items-center">
                <span className="font-medium">Over price</span>
                <input
                    className="border p-2 border-black rounded-xl"
                    value={price}
                    onChange={(e) => {let value = e.target.value.replace(",", "."); setPrice(value)}}
                    style={{ maxWidth: "150px" }}
                />
            </div>
            {isNewPriceValid(weight, price) && (
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.7rem",
                        padding: "5px 10px",
                        ":hover": {
                            bgcolor: "#065f46",
                        },
                    }}
                    onClick={handleCreateOverPrice}
                >
                    Create
                </Button>
            )}
        </div>
    );
};

export default CreateOverPrice;
